import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';

export const practitionerDrawerAction: UseResourceDrawerOpenDrawerArgs<'Practitioner'>['action'] =
  ({ model, requestContext }) => {
    const builderId = requestContext.builderId ?? '';
    return {
      label: 'Care Team Practitioner',
      title: model.practitionerName,
      content: {
        body: (
          <ContentCard variant="focal" title="Details">
            <DefinitionList
              items={[
                { label: 'Organization', value: model.managingOrganization },
                { label: 'Care Team', value: model.careTeam.categoryDisplay },
                { label: 'Phone', value: model.careTeam.phone },
                { label: 'Role', value: model.role },
                { label: 'Specialty', value: model.specialty },
                { label: 'Member Since', value: model.effectiveStartDate },
                { label: 'Data Source', value: model.getDataSourceDisplay(builderId) },
              ]}
            />
          </ContentCard>
        ),
      },
    };
  };
